var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-toolbar",
    { attrs: { text: "", dark: "", height: "64px" } },
    [
      _c(
        "v-list",
        [
          _c(
            "v-list-item",
            { staticClass: "px-0" },
            [
              !_vm.isLoggedAs
                ? _c(
                    "v-list-item-avatar",
                    { staticClass: "tile-menu-avatar" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "menu-avatar",
                          domProps: { textContent: _vm._s(_vm.user_avatar) }
                        },
                        [_vm._v("?")]
                      )
                    ]
                  )
                : _vm._e(),
              _vm.isLoggedAs
                ? _c(
                    "v-list-item-avatar",
                    { staticClass: "menu-avatar" },
                    [_c("v-icon", [_vm._v("transfer_within_a_station")])],
                    1
                  )
                : _vm._e(),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", {
                    domProps: { textContent: _vm._s(_vm.user_login) }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }